import React from "react";
import { Modal } from "react-bootstrap";

interface IModalProps {
    show?: boolean;
    onHide?: (params?: any) => void;
    header?: React.ReactNode;
    body: React.ReactNode;
    children?: React.ReactNode;
    zIndex?: number;
    style?: React.CSSProperties;
    showHeader?: boolean;
    enforceFocus?: boolean;
}

interface Props {
    children: React.ReactNode;
}

export const DefaultModalHeader: React.FC<Props> = ({ children }) => {
    return (
        <Modal.Header closeButton>
            <Modal.Title>Modal Title</Modal.Title>
        </Modal.Header>
    );
};

export const ModalHeader: React.FC<Props> = ({ children }) => {
    return (
        <Modal.Header closeButton>
            <Modal.Title>{children}</Modal.Title>
        </Modal.Header>
    );
};

export const FullScreenModal: React.FC<IModalProps> = ({
    show,
    onHide,
    header,
    body,
    zIndex,
    style,
    showHeader = true,
    enforceFocus = true,
}) => {
    const onHideHandler = React.useCallback(() => {
        if (onHide) {
            onHide();
        }
    }, [onHide]);

    const isCustomSize = !!style;

    return (
        <Modal
            show={show}
            {...(!isCustomSize && { fullscreen: true })}
            onHide={onHideHandler}
            style={{ zIndex, ...style }}
            centered
            enforceFocus={enforceFocus}
        >
            {/* Show Header only if showHeader is true */}
            {showHeader && (header ? header : <DefaultModalHeader children={undefined} />)}

            <Modal.Body>{body}</Modal.Body>
        </Modal>
    );
};
